/* eslint-disable camelcase */
import React, { useState } from 'react';
import cn from 'classnames';
import Link from 'next/link';

import HubspotForm from 'react-hubspot-form';

import Button from 'react-scale/components/elements/button';

import styles from './simple-form.module.css';

const setHiddenUTMFields = () => {
  let utmParams = {};
  try {
    utmParams = JSON.parse(window.localStorage.getItem('utm_params') || '{}');
    Object.keys(utmParams).forEach(property => {
      const utmField = document.querySelector(`input[name=${property}]`);
      if (utmField) {
        utmField.value = utmParams[property] ?? '';
      }
    });
  } catch (error) {
    // NOTE: ignore error, using localStorage/sessionStorage is disabled in incognito.
  }
};

const ContactInput = ({ form, duplicateId, theme }) => {
  const [show, setShowCondition] = useState(false);
  const [button, setShowButton] = useState(true);

  const setupStyle = () => {
    const emailInput = document.querySelector(`#email-${form.id}_${duplicateId}`);

    emailInput.addEventListener('focus', () => {
      setShowCondition(true);
    });
  };

  return (
    <div className="relative items-center block w-full lg:flex">
      <div className="w-full">
        <div className="flex flex-col w-full md:flex-row md:gap-4">
          <div className={`${styles.formContent} w-full`}>
            <HubspotForm
              portalId="4823527"
              formId={form.id}
              formInstanceId={duplicateId} // When embedding the same form on the same page twice, provide this Id for each identical form embed.
              cssClass={`${styles.simpleForm} flex justify-between`}
              translations={{
                en: {
                  submitText: form.label
                }
              }}
              submitButtonClass="hidden"
              onReady={() => {
                setupStyle();
                setHiddenUTMFields();
              }}
              loading={<FormStaticLoading />}
            />
          </div>
          {button && (
            <Button
              onClick={() => {
                document.forms[0].submit();
                setShowButton(false);
                setShowCondition(false);
              }}
              text={form.label}
              theme={theme}
            />
          )}
        </div>
        <p
          className={cn(
            'mobile-spacing text-sm text-silver text-left transition-all duration-200 ease-in',
            show
              ? 'opacity-1 select-auto pointer-events-auto h-10 mt-4'
              : 'opacity-0 select-none pointer-events-none h-0'
          )}
        >
          By proceeding you agree to Scale AI’s{' '}
          <Link href="/legal/terms" className="text-white">
            Privacy Policy
          </Link>
          , and you consent to receive marketing communications.
        </p>
      </div>
    </div>
  );
};

const FormStaticLoading = () => (
  <div style={{ display: 'block' }}>
    <form className={styles.simpleForm}>
      <div className="hs_email hs-email hs-fieldtype-text field hs-form-field">
        <div className="input">
          <input
            className="hs-input"
            type="email"
            name="email"
            required=""
            placeholder="Enter your work email"
          />
        </div>
      </div>
    </form>
  </div>
);

ContactInput.defaultProps = {
  theme: 'dark',
  form: {
    id: '1d163103-bd52-43cb-8fe1-8da65276d3db',
    label: 'Get in Touch'
  },
  duplicateId: 1 // When embedding the same form on the same page twice, provide this Id for each identical form embed.
};

export default ContactInput;
